import React, { useState } from 'react';
import PropTypes from 'prop-types';
// common components
import AuthBackground from './../AuthBackground/AuthBackground';
import FormField from './../../../common/Forms/FormField/FormField';
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import { email } from './../../../common/Forms/Validation/FieldLevelValidation';
// css
import './Login.scss';

const Login = ({ loginContext, history }) => {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');

	return (
		<AuthBackground>
			{
				loginContext.loginError !== '' && 
				<div className='login-error'>{loginContext.loginError}</div>
			}
			<form onSubmit={(e) => {
				e.preventDefault();
				loginContext.onLoginSubmit({username, password}, history)
			}}>
				<FormField
					autoFocus
					label="Email"
					name="username"
					placeholder="Enter Username"
					value={ username }
					onChange={ e => setUsername(e.target.value) }
					validate={['required', 'email']}
				/>
				<FormField
					label="Password"
					name="password"
					type="password"
					placeholder="Enter Password"
					value={ password }
					onChange={ e => setPassword(e.target.value) }
					validate={['required']}
					maxLength={50}
				/>				
				<CustomButton
					name="submit"
					type="submit"
					disabled={ username === '' || password === '' || typeof email(username) === 'string' }
				/>
			</form>			
		</AuthBackground>
	);
}

Login.propTypes = {
    value: PropTypes.instanceOf(Object),
    history: PropTypes.instanceOf(Object)
};

Login.defaultProps = {
    value: {},
    history: {}
};

export default Login;



// WEBPACK FOOTER //
// ./components/Auth/Login/Login.js